import clsx from 'clsx';

interface RadioInputProps {
  className?: string;
  field: string;
  caption?: string;
  required?: boolean;
  formStyle?: boolean;
  error?: string;
  values?: (string | { value: string; label?: string })[];
  value?: string;
  onChange?: (value: string) => void;
}

export const RadioInput = (props: RadioInputProps) => {
  return (
    <div className='relative mb-[25px]'>
      <div className='mb-1.5'>
        {props.required && <span className='pr-2 text-xl'>*</span>}
        <label className='text-lg  tracking-[-0.1px] leading-[25px] text-[#4c4c52] mb-2'>{props.caption}</label>
      </div>
      <div className='leading-10'>
        {props.values?.map((item, i) => {
          const value = typeof item === 'object' ? item.value : item;
          const label = typeof item === 'object' ? item.label || item.value : item;
          const id = `${props.field}-${i}`;

          return (
            <div key={i} className='inline-flex items-center mr-8'>
              <div className='relative flex items-center'>
                <input
                  className='absolute w-5 h-5 opacity-0 cursor-pointer peer'
                  type='radio'
                  name={props.field}
                  required={props.required}
                  value={value}
                  checked={value === props.value}
                  onChange={(e) => props.onChange?.(e.target.value)}
                  id={id}
                />
                <div
                  className={clsx(
                    'w-4 h-4 rounded-full border shadow-[inset_0_2px_6px_0_rgba(85,85,90,0.39)] border-[#5d5d62]',
                    'peer-checked:border-4',
                    'transition-all duration-200',
                  )}
                >
                  {value === props.value && <div className='absolute inset-1 bg-white rounded-full'></div>}
                </div>
              </div>
              <label htmlFor={id} className='ml-2 text-gray-700 cursor-pointer'>
                {label}
              </label>
            </div>
          );
        })}
      </div>
      {props.error && (
        <div
          className={clsx(
            'text-sm left-0 mt-0  top-full text-[#d44112] tracking-[-0.1px] text-left whitespace-pre-line',
            props.formStyle && 'absolute top-0',
          )}
        >
          {props.error}
        </div>
      )}
    </div>
  );
};
